module.exports = __webpack_public_path__ + "img/LoadingBar.edeeac7c.svg";